export const ButtonTypes = {
    LABEL: "Label",
    PRODUCT_SIGNUP_AND_LEARN_MORE: "Product signup and learn more"
};
